/**
 * Skeleton loader components for better loading UX
 */

export function SkeletonCard() {
  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-4 sm:p-6 animate-pulse">
      <div className="h-4 bg-gray-200 rounded w-3/4 mb-4"></div>
      <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
      <div className="h-4 bg-gray-200 rounded w-2/3"></div>
    </div>
  );
}

export function SkeletonTable({ rows = 5, cols = 4 }) {
  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm overflow-hidden animate-pulse">
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="h-4 bg-gray-200 rounded w-1/4"></div>
      </div>
      <div className="divide-y divide-gray-200">
        {Array.from({ length: rows }).map((_, i) => (
          <div key={i} className="px-4 py-4">
            <div className="flex gap-4">
              {Array.from({ length: cols }).map((_, j) => (
                <div
                  key={j}
                  className="h-4 bg-gray-200 rounded flex-1"
                ></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SkeletonImage({ className = "w-full h-48" }) {
  return (
    <div
      className={`bg-gray-200 rounded-lg animate-pulse ${className}`}
    ></div>
  );
}

export function SkeletonGrid({ count = 4 }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-6">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
}

const SkeletonComponents = {
  SkeletonCard,
  SkeletonTable,
  SkeletonImage,
  SkeletonGrid,
};

export default SkeletonComponents;
